import { Link } from 'react-router-dom';

export default function Footer() {
  const categoryLinks = [
    { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
    { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
    { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
    { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
    { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
    { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
    { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
    { name: 'Underwear/Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
    { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
    { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
    { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
    { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
    { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
    { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
  ];

  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="section-container section-padding">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="font-heading text-2xl text-background-50">
              Basetao Sheet
            </Link>
            <p className="mt-4 text-secondary-200 text-sm leading-relaxed">
              Your independent resource for Basetao Spreadsheet guides, product databases, reviews, and shopping tips. We help shoppers discover the best products through organized spreadsheets.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-lg mb-4 text-background-50">Quick Links</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-secondary-200 text-sm hover:text-background-50 transition-colors whitespace-nowrap">Home</Link>
              <a href="#categories" className="text-secondary-200 text-sm hover:text-background-50 transition-colors whitespace-nowrap">Categories</a>
              <a href="#about" className="text-secondary-200 text-sm hover:text-background-50 transition-colors whitespace-nowrap">About Basetao Spreadsheet</a>
              <Link to="/basetao-spreadsheet-guide" className="text-secondary-200 text-sm hover:text-background-50 transition-colors whitespace-nowrap">Complete Guide</Link>
              <a href="#faq" className="text-secondary-200 text-sm hover:text-background-50 transition-colors whitespace-nowrap">FAQ</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-lg mb-4 text-background-50">Popular Categories</h4>
            <div className="flex flex-col gap-2.5">
              {categoryLinks.slice(0, 7).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-secondary-200 text-sm hover:text-background-50 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-lg mb-4 text-background-50">More Categories</h4>
            <div className="flex flex-col gap-2.5">
              {categoryLinks.slice(7).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-secondary-200 text-sm hover:text-background-50 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-secondary-400/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-secondary-300 text-sm">
            &copy; {new Date().getFullYear()} Basetao Sheet. An independent resource. Not affiliated with Basetao.
          </p>
          <div className="flex items-center gap-6">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-secondary-300 text-sm hover:text-background-50 transition-colors whitespace-nowrap"
            >
              Visit Main Site
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-1.5 text-background-50 bg-accent-500 hover:bg-accent-400 px-5 py-2.5 rounded-md text-sm font-medium transition-colors whitespace-nowrap"
            >
              Basetao Spreadsheet <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}